import React from "react";

const Header = () => {
  return (
    <div className="header">
      <div className="logo-container">
        <img src="https://files.catbox.moe/d8z3qs.PNG" alt="CONFRONTER TECH LOGO" />
      </div>
      <h3>M-PESA CHECKOUT</h3>
    </div>
  );
};

export default Header;
